import Vue from 'vue'
import App from './App'
import router from './router'

import './assets/public/index.css'
import './assets/font/font.css'
import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
 
 

 

// import VConsole from 'vconsole'

// if (process.env.NODE_ENV !== 'production') {
//   new VConsole()
// }

var _hmt = _hmt || [];
(function () {
  var hm = document.createElement("script");
  var host = window.location.host;
  if (host.indexOf('sailyond.com') >= 0) {
    hm.src = "https://hm.baidu.com/hm.js?36674757b37088ea90821f7d87ebc501"
  } else {
    hm.src = "https://hm.baidu.com/hm.js?39323110192b834c5d4ec4a31f5dbd5e"
  }
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

// Reference URL:
// https://tongji.baidu.com/holmes/Analytics/%E6%8A%80%E6%9C%AF%E6%8C%87%E5%8D%97/JS%20API/JS%20API%20%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C#27-_setpageviewproperty:~:text=2.7-,_setPageviewProperty,-%E5%88%86%E6%9E%90%E4%BA%91%E6%94%AF%E6%8C%81
router.afterEach((to, from) => {
  window._hmt = window._hmt || [];

  // 1. 设置 PV 属性
  // 注：您也可以在页面内相关生命周期函数内赋值，确保对应函数的执行时机早于 afterEach 中 _trackPageview 的调用即可
  window._hmt.push(['_setPageviewProperty', {
    page_name: to.name,
    page_title: null    // 当属性值传入 null 时，其作用为删除此前设置的该 PV 属性
}]);

  // 2. 发送 PV 日志
  window._hmt.push(['_trackPageview', to.path]);
})


Vue.config.productionTip = false
// Vue.use(ElementUI)
Vue.use(VueFullPage)
Vue.prototype.$video = Video

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js